import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const userImpersonation: CaptionRecord = {
  impersonate: () => captionService.getString("d1e8f8e2-9b4f-4c3d-8b8e-2b5e6f8c4b2e", "Impersonate"),
  impersonatingWarning: () =>
    captionService.getString(
      "f9c4d1ae-9050-4ef0-bcca-00621e4d1ae0",
      "You are now impersonating this user, any action you take will be logged as this user and NOT you!",
    ),
  impersonateUser: () => captionService.getString("a2f4d1ae-9050-4ef0-bcca-00621e4d1ae0", "Impersonate User"),
  searchUsers: () => captionService.getString("b3cb4ef0-9050-4ef0-bcca-00621e4d1ae0", "Search for User"),
  error: () => captionService.getString("c4ecb4ef0-9050-4ef0-bcca-00621e4d1ae0", "Impersonate Error"),
};
